import type { SupplierProductGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import ProductItemDialogDetails from "./ProductItemDialogDetails";
import ProductItemDialogPricing from "./ProductItemDialogPricing";
import { ProductItemDialogPages } from "./ItemDetailsDialog.shared";

export type ProductItemDialogPagesType = {
  PRODUCT_DETAILS: number;
  PRODUCT_PRICING: number;
};

interface ProductItemDetailsDialogType extends Pick<
  SupplierProductGetResponseType,
  | "vegan"
  | "lactoseFree"
  | "glutenFree"
  | "containerType"
  | "unit"
  | "packQuantity"
  | "weight"
  | "volume"
  | "sku"
  | "id"
> {
  Parent: Pick<
    SupplierProductGetResponseType,
    "vegan" | "lactoseFree" | "glutenFree" | "id" | "active"
  > | null;
}

export default function ItemDetailsDialog({
  active,
  onDismiss,
  product,
}: {
  active: boolean;
  onDismiss: (productId?: number) => void;
  product?: ProductItemDetailsDialogType;
}) {
  const [step, setStep] = useState<number>(
    ProductItemDialogPages.PRODUCT_DETAILS,
  );
  const [productId, setProductId] = useState<number>();
  const mode = product ? "Update" : "Add";

  const dismissDialog = () => {
    setStep(ProductItemDialogPages.PRODUCT_DETAILS);
    onDismiss(productId);
  };

  return (
    <Dialog active={active} onDismiss={dismissDialog}>
      <DialogNavigation
        title={`${mode} item`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={dismissDialog}
      />
      <DialogContent>
        {!!product && !!product.Parent && (
          <>
            {step === ProductItemDialogPages.PRODUCT_DETAILS && (
              <ProductItemDialogDetails
                parentProduct={product.Parent}
                onDismiss={onDismiss}
                product={product}
                setStep={setStep}
                setProductId={setProductId}
              />
            )}

            {step === ProductItemDialogPages.PRODUCT_PRICING && (
              <>
                {productId && (
                  <ProductItemDialogPricing
                    productId={productId}
                    onDismiss={onDismiss}
                    parentActive={product.Parent.active}
                    setStep={setStep}
                  />
                )}
              </>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
